import { RestaurantEvent } from './types';
import { handleNewOrderCreated } from './orderCreated.handler';

export function manageEvent(event: RestaurantEvent): void {
	switch (event.type) {
		case 'ORDER_CREATED':
			handleNewOrderCreated(/* event as OrderCreatedType */);
			break;
		default:
			break;
	}
}
